<app-project-submenu></app-project-submenu>

<div class="d-flex align-items-center justify-content-between mt-3 mb-3">
    <h5 class="mb-0">{{ this.userName }}</h5>
    <p-button
        size="small"
        severity="secondary"
        outlined="true"
        (onClick)="back()"
        i18n-label="@@back-button"
        label="Zurück"
    ></p-button>
</div>

<p-table
  [value]="this.entries"
  [rowHover]="true"
  styleClass="p-datatable-m"
  >
  <ng-template pTemplate="header">
    @if (this.entries.length > 0) {
      <tr>
        <th i18n="@@quiz-question-column">Frage</th>
        <th i18n="@@quiz-given-answer-column">Antwort</th>
        <th i18n="@@quiz-correct-answer-column">Richtige Antwort</th>
        <th i18n="@@quiz-result-column">Ergebnis</th>
        <th i18n="@@quiz-bot-column">Bot</th>
        <th i18n="@@quiz-skillid-column">Identifikator</th>
        <th i18n="@@quiz-time-column">Zeitpunkt</th>
      </tr>
    }
  </ng-template>

  <ng-template
    pTemplate="body"
    let-entry
    >
    <tr>
      <td>{{ entry.question }}</td>
      <td>{{ entry.givenAnswer }}</td>
      <td>{{ entry.correctAnswer }}</td>
      <td>
        <p-tag
          [value]="entry.correct ? richtigLabel : falschLabel"
          [severity]="entry.correct ? 'success' : 'danger'"
        ></p-tag>
      </td>
      <td>{{ entry.botName }}</td>
      <td>{{ entry.skillId }}</td>
      <td>{{ entry.answeredAt | date:'dd.MM.yyyy HH:mm' }}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td
        colspan="7"
        class="text-center p-5 text-muted"
        i18n="@@quiz-user-history-empty-state"
        >
                Für diesen Nutzer liegt noch kein Quiz-Verlauf vor.
            </td>
        </tr>
    </ng-template>
</p-table>
